import { SelectableTransaction } from './selectable-transaction';

export class SelectableDisabledTransaction extends SelectableTransaction {
  disabled: boolean; // used to disable checkbox for already added transaction
}
